var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('b-spinner',{attrs:{"label":"Spinning"}}),_c('div',{staticClass:"mt-2"},[_vm._v("Bitte warten")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }